"use strict";
var component_loader_class_1 = require('./component-loader.class');
exports.ComponentLoader = component_loader_class_1.ComponentLoader;
var component_loader_factory_1 = require('./component-loader.factory');
exports.ComponentLoaderFactory = component_loader_factory_1.ComponentLoaderFactory;
var content_ref_class_1 = require('./content-ref.class');
exports.ContentRef = content_ref_class_1.ContentRef;



//////////////////
// WEBPACK FOOTER
// ./resources/themes/pandax/bobtail/~/ng2-bootstrap/component-loader/index.js
// module id = 494
// module chunks = 1